import styled from 'styled-components';
import { OHeroContentBlockDesktopContentAlignment, OHeroContentBlockImageScale } from './OHeroContentBlock.types';
import { baseVariables } from '../../styles';

export const HeroContentBlockWrapper = styled.div<{
  $desktopContentAlignment: OHeroContentBlockDesktopContentAlignment;
  $imageScale: OHeroContentBlockImageScale;
}>`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--t-brand-bg-color);
  color: var(--t-brand-fg-color);

  @media ${baseVariables.mediaQuery.md} {
    flex-direction: row;
    align-items: center;
  }

  @media ${baseVariables.mediaQuery.lg} {
    min-height: ${({ $imageScale }) => {
      switch ($imageScale) {
        case OHeroContentBlockImageScale.SMALL:
          return '400px';
        case OHeroContentBlockImageScale.MEDIUM:
          return '600px';
        case OHeroContentBlockImageScale.LARGE:
          return '800px';
        default:
          return '600px';
      }
    }};
  }
`;

export const ImageContainer = styled.div<{
  $imageScale: OHeroContentBlockImageScale;
}>`
  width: 100%;
  position: absolute;
  overflow: hidden;

  .hero-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const ContentContainer = styled.div<{
  $desktopContentAlignment: OHeroContentBlockDesktopContentAlignment;
}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-block: 2rem;
  padding-inline: 1rem;
  background-color: var(--t-brand-bg-color);
  z-index: 1;
  border-radius: var(--t-cards-border-radius);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
  position: absolute;
  flex-basis: content;
  ${({ $desktopContentAlignment }) => {
    switch ($desktopContentAlignment) {
      case OHeroContentBlockDesktopContentAlignment.LEFT:
        return 'left: 0';
      case OHeroContentBlockDesktopContentAlignment.CENTER:
        return 'margin: auto; position: unset;';
      case OHeroContentBlockDesktopContentAlignment.RIGHT:
        return 'right: 0';
      default:
        return 'margin: auto;position: unset;';
    }
  }};

  @media ${baseVariables.mediaQuery.md} {
    width: 50%;
    padding-block: 3rem;
    padding-inline: 2rem;
  }

  @media ${baseVariables.mediaQuery.lg} {
    width: 50%;
    padding-block: 4rem;
    padding-inline: 3rem;
  }
`;

export const ContentInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 100%;

  @media ${baseVariables.mediaQuery.md} {
    gap: 2rem;
  }

  @media ${baseVariables.mediaQuery.lg} {
    max-width: 600px;
  }
`;

export const BrandElementWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-block-end: 0.5rem;
`;

export const TextBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonGroupWrapper = styled.div<{
  $hasSecondaryButton: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-block-start: 0.5rem;

  @media ${baseVariables.mediaQuery.md} {
    flex-direction: ${({ $hasSecondaryButton }) => ($hasSecondaryButton ? 'row' : 'column')};
    gap: 1rem;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;

  @media ${baseVariables.mediaQuery.md} {
    flex: 0 0 auto;
  }
`;

export const PhotoCaptionWrapper = styled.div`
  display: flex;
  margin-block-start: 1rem;
`;
